import React from 'react';
import { Box, ResponsiveContext, Spinner } from 'grommet';

const LoadSearches = () => {
  return (
    <ResponsiveContext.Consumer>
      {size => (
        <Box
          align='center'
          justify='center'
          height='100vh'
        >
          <Box
            align='center'
            width='medium'
            pad={ size === 'small' ? 'large' : 'small' }
          >
            <Spinner size='medium' />
          </Box>
        </Box>
      )}
    </ResponsiveContext.Consumer>
  )
}

export default LoadSearches;
